import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { IoMdClose } from "react-icons/io";
import { showIconByServiceId } from "../../../helper/showIconByServiceId";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {FaEye, FaFileExcel, FaPencilAlt} from "react-icons/fa";
import { Link } from "react-router-dom";
import {ability} from "../../../config/acl/ability";
import {Can} from "../../Can";
import {api_Routes} from "../../../tools/api_Routes";
import {Helper} from "../../../tools/Helper";
import * as XLSX from "xlsx";
import PaymentStatusChanger from "../status-chenger/PaymentStatusChanger";

const DataTable = ({ data, setData, rowsPerPage, currentPage,filters }) => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const canUpdatedTransaction = ability.can('transaction', 'update');

  // Handle sorting logic
  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = [...data].sort((a, b) => {
    if (!orderBy) return 0;
    if (a[orderBy] === null || b[orderBy] === null) return 0; // Null-safe comparison
    if (a[orderBy] < b[orderBy]) return order === "asc" ? -1 : 1;
    if (a[orderBy] > b[orderBy]) return order === "asc" ? 1 : -1;
    return 0;
  });

  // Export PDF
  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("services Table", 14, 10);
    doc.autoTable({
      startY: 20,
      head: [
        [
          "ID",
          "Service",
          "Service Type",
          "User Name",
          "Price",
          "Panel URL",
          "Payment Method",
          "Created At",
          "Status Payment",
          "Note",
          "Balance Type",
          "Status",
        ],
      ],
      body: sortedData.map((item) => [
        item.request_id,
        item.our_service || "N/A",
        item.our_service_type || "N/A",
        item.user_name || "N/A",
        item.price || "N/A",
        item.panel_url || "N/A",
        item.payment_method || "N/A",
        item.created_at || "N/A",
        item.status_payment || "N/A",
        item.payment_details || "N/A",
        item.balance_type || "N/A",
        item.status || "N/A",
      ]),
    });
    doc.save("ServicesTable.pdf");
  };
  const [exportLoading, setExportLoading] = useState(false);
  const exportToExcel = async () => {
    setExportLoading(true);
    try {
      // Build query string from filters (same as parent component)
      const queryParams = [];
      if (filters.dateRange.start && filters.dateRange.end) {
        queryParams.push(`start_date=${filters.dateRange.start.toISOString().split("T")[0]}`);
        queryParams.push(`end_date=${filters.dateRange.end.toISOString().split("T")[0]}`);
      } else if (filters.dateRange.end) {
        queryParams.push(`end_date=${filters.dateRange.end.toISOString().split("T")[0]}`);
      }
      if (filters.orderStatus && filters.orderStatus !== "null") {
        queryParams.push(`order_status=${filters.orderStatus}`);
      }
      if (filters.paymentStatus && filters.paymentStatus !== "null") {
        queryParams.push(`payment_status=${filters.paymentStatus}`);
      }
      if (filters.source && filters.source !== "null") {
        queryParams.push(`source=${filters.source}`);
      }
      if (filters.panelUrl) {
        queryParams.push(`panel_url=${encodeURIComponent(filters.panelUrl)}`);
      }

      const queryString = queryParams.length ? `${queryParams.join("&")}` : "";
      const url = `${api_Routes.Deposits.Export}?${queryString}`;

      const { response, message } = await Helper.Get({
        url,
        hasToken: true,
      });

      if (response) {
        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(
            response.data.map(item => ({
              ID: item.id,
              "Transaction Id": item.transaction_id || "N/A",
              Gateway: item.gateway || "N/A",
              Amount: item.amount || "N/A",
              Status: item.status || "N/A",
              'Payment Details': item.payment_details || "N/A",
              'Balance Type': item.balance_type || "N/A",
              'Paid At': item.paid_at || "N/A",
              'Created At': item.created_at || "N/A",
              'Username':item.payable.name,
              'Email':item.payable.email,
              'Reseller':item.payable.reseller,
            }))
        );

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Deposits");

        // Export file
        XLSX.writeFile(workbook, `Deposits_Export_${new Date().toISOString().split('T')[0]}.xlsx`);
      } else {
        throw new Error(message || 'Failed to export data');
      }

    } catch (error) {
      console.error('Export error:', error);
      alert('Failed to export data. Please try again.');
    } finally {
      setExportLoading(false);
    }
  };

  return (
    <>
      {/*<button*/}
      {/*  onClick={exportPDF}*/}
      {/*  className="bg-primary text-white p-2 rounded mb-3"*/}
      {/*>*/}
      {/*  Export to PDF*/}
      {/*</button>*/}
      <Can I={'export'} a={'orders'}>
        <button
            onClick={exportToExcel}
            disabled={exportLoading}
            className="bg-green-600 text-white p-2 rounded flex items-center gap-2 disabled:opacity-50"
        >
          <FaFileExcel />
          {exportLoading ? 'Exporting...' : 'Export to Excel'}
        </button>
      </Can>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow className="bg-primary">
              {[
                { label: "ID", key: "id" },
                { label: "Transaction Id", key: "transaction_id" },
                { label: "User Name", key: "user_name" },
                { label: "Amount", key: "price" },
                { label: "Payment Method", key: "gateway" },
                { label: "Balance Type", key: "balance_type" },
                { label: "Note", key: "payment_details" },
                { label: "Reseller", key: "reseller" },
                { label: "Created At", key: "created_at" },
                { label: "Paid At", key: "paid_at" },
                { label: "Status", key: "status" },
                // { label: "Action", key: "action" },
              ].map((column) => (
                <TableCell
                  align="center"
                  className="!text-darkTextColor whitespace-nowrap"
                  key={column.label}
                  onClick={
                    column.key ? () => handleSort(column.key) : undefined
                  }
                  style={{ cursor: column.key ? "pointer" : "default" }}
                >
                  {column.label}
                  {column.key &&
                    (orderBy === column.key ? (
                      order === "asc" ? (
                        <span> ▲</span>
                      ) : (
                        <span> ▼</span>
                      )
                    ) : (
                      ""
                    ))}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData.map((item) => (
              <TableRow
                key={item.request_id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="center">{item?.id}</TableCell>
                <TableCell align="center">{item?.transaction_id}</TableCell>
                <TableCell align="center">
                  {item?.payable?.name}
                </TableCell>
                <TableCell align="center">{item?.amount}{item?.currency}</TableCell>
                <TableCell align="center">{item?.gateway}</TableCell>
                <TableCell align="center">{item?.balance_type}</TableCell>
                <TableCell align="center">{(item?.gateway === 'manual by admin'||item?.gateway === 'Register Bonus')  ?item?.payment_details : ""}</TableCell>
                <TableCell align="center">{item?.payable?.reseller}</TableCell>
                <TableCell align="center">{item?.created_at}</TableCell>
                <TableCell align="center">{item?.paid_at}</TableCell>
                <TableCell align="center">
                  {
                    canUpdatedTransaction ?
                    item?.status === 'success' ?
                  item?.status :
                      <PaymentStatusChanger
                          data={item}
                          setData={setData}
                          rowsPerPage={rowsPerPage}
                          currentPage={currentPage}
                      /> :
                        item?.status
                  }

                </TableCell>
                {/*<TableCell align="center">*/}
                {/*  <Link*/}
                {/*    to={`/Orders/${item?.uuid}`}*/}
                {/*    color="inherit"*/}
                {/*    underline="none"*/}
                {/*  >*/}
                {/*    <FaEye className="text-[#6c757d]" />*/}
                {/*  </Link>*/}
                {/*</TableCell>*/}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default DataTable;
